import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { fetchScopeData } from "../../../../api/fetchScopeData";
import GlobalButton from "../../../common/GlobalButton"; // Add this import
import LogsIconDesign from "../../../common/LogsIconDesign"; // Add this import
export default function LogButtonScope() {
  const [open, setOpen] = useState(false);
  const [logData, setLogData] = useState([]);

  const handleOpen = async () => {
    setOpen(true);
    try {
      const data = await fetchScopeData();
      setLogData(data);
    } catch (error) {
      console.error("❌ Error fetching log data:", error);
    }
  };

  const handleClose = () => setOpen(false);

  const fieldsToShow = [
    "ID",
    "Added_User",
    "Modified_User",
    "Added_Time",
    "Modified_Time",
  ];

  return (
    <>
      <LogsIconDesign
        size="small"
        variant="contained"
        onClick={handleOpen}
        sx={{ minWidth: 80, height: 36, px: 2, py: 0.5 }}
      />
      <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
        <DialogTitle>Scope Data Logs</DialogTitle>
        <DialogContent>
          {logData.length === 0 ? (
            <Typography color="text.secondary">
              No scope data available.
            </Typography>
          ) : (
            logData.map((item) => (
              <div key={item.id} style={{ marginBottom: "20px" }}>
                <Table>
                  <TableHead>
                    <TableRow style={{ backgroundColor: "#f5f5f5" }}>
                      <TableCell style={{ fontWeight: "bold" }}>
                        Field
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>
                        Value
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {fieldsToShow.map((field) => (
                      <TableRow key={field}>
                        <TableCell>{field}</TableCell>
                        <TableCell>
                          {typeof item[field] === "string" &&
                          item[field].length > 100
                            ? `${item[field].substring(0, 100)}...` // Truncate long strings
                            : JSON.stringify(item[field], null, 2)}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            ))
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
